
import DashboardMemoItem from './DashboardMemoItem.vue';

export default {
  name: 'DashboardMemosRail',
  components: {
    DashboardMemoItem
  },
  props: {
    open: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    activeCategory: {
      type: String,
      default: 'all'
    },
    categories: {
      type: Array,
      default: () => []
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Memos'
    },
    emptyLabel: {
      type: String,
      default: 'No memos yet'
    },
    loadMoreLabel: {
      type: String,
      default: 'Load more'
    }
  },
  data() {
    return {
      isDraggingChips: false,
      dragStartX: 0,
      dragStartScrollLeft: 0
    };
  },
  computed: {
    filteredItems() {
      if (this.activeCategory === 'all') return this.items;

      return this.items.filter(item => item.category === this.activeCategory);
    }
  },
  methods: {
    startDragScroll(event) {
      if (!this.$refs.chipsScroller) return;
      this.isDraggingChips = true;
      this.dragStartX = event.pageX;
      this.dragStartScrollLeft = this.$refs.chipsScroller.scrollLeft;
    },
    onDragScroll(event) {
      if (!this.isDraggingChips || !this.$refs.chipsScroller) return;
      const delta = event.pageX - this.dragStartX;
      this.$refs.chipsScroller.scrollLeft = this.dragStartScrollLeft - delta;
    },
    stopDragScroll() {
      this.isDraggingChips = false;
    }
  }
};
